import { Icon } from "@rmwc/icon";
import "@rmwc/icon/styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { clearError, getError, subscribe } from "./ErrorOverlayStore";
import "./ErrorOverlay.css";

/**
 * Contenu commun (icône erreur, titre, message, bouton) – style grave (rouge)
 */
function ErrorContent({ title, message, onDismiss, dismissLabel }) {
  return (
    <>
      <div className="ErrorOverlay-Icon ErrorOverlay-Icon--grave">
        <Icon icon="error" />
      </div>
      {title && <div className="ErrorOverlay-Title">{title}</div>}
      <div className="ErrorOverlay-Message">{message}</div>
      <button type="button" className="ErrorOverlay-Button ErrorOverlay-Button--grave" onClick={onDismiss}>
        {dismissLabel}
      </button>
    </>
  );
}

function ErrorOverlayOption1({ error, onDismiss, dismissLabel }) {
  if (!error) return null;
  const { message, title } = error;
  return (
    <div className="ErrorOverlay-Option1">
      <div className="ErrorOverlay-Option1-Card ErrorOverlay-Option1-Card--grave">
        <ErrorContent title={title} message={message} onDismiss={onDismiss} dismissLabel={dismissLabel} />
      </div>
    </div>
  );
}

function ErrorOverlayOption2({ error, onDismiss, dismissLabel }) {
  if (!error) return null;
  const { message, title } = error;
  return (
    <div className="ErrorOverlay-Option2">
      <div className="ErrorOverlay-Option2-Card ErrorOverlay-Option2-Card--grave">
        <div className="ErrorOverlay-Icon ErrorOverlay-Icon--grave">
          <Icon icon="error" />
        </div>
        <div className="ErrorOverlay-Content">
          {title && <div className="ErrorOverlay-Title">{title}</div>}
          <div className="ErrorOverlay-Message">{message}</div>
        </div>
        <button type="button" className="ErrorOverlay-Button ErrorOverlay-Button--grave" onClick={onDismiss}>
          {dismissLabel}
        </button>
      </div>
    </div>
  );
}

function ErrorOverlayOption3({ error, onDismiss, dismissLabel }) {
  if (!error) return null;
  const { message, title } = error;
  return (
    <div className="ErrorOverlay-Option3">
      <div className="ErrorOverlay-Option3-Card ErrorOverlay-Option3-Card--grave">
        <ErrorContent title={title} message={message} onDismiss={onDismiss} dismissLabel={dismissLabel} />
      </div>
    </div>
  );
}

function ErrorOverlayOption4({ error, onDismiss, dismissLabel }) {
  if (!error) return null;
  const { message, title } = error;
  return (
    <div className="ErrorOverlay-Option4">
      <div className="ErrorOverlay-Option4-Card ErrorOverlay-Option4-Card--grave">
        <ErrorContent title={title} message={message} onDismiss={onDismiss} dismissLabel={dismissLabel} />
      </div>
    </div>
  );
}

function ErrorOverlayOption5({ error, onDismiss, dismissLabel }) {
  if (!error) return null;
  const { message, title } = error;
  return (
    <div className="ErrorOverlay-Option5">
      <div className="ErrorOverlay-Option5-Card ErrorOverlay-Option5-Card--grave">
        <div className="ErrorOverlay-Option5-Ring">
          <Icon icon="error" />
        </div>
        {title && <div className="ErrorOverlay-Option5-Title">{title}</div>}
        <div className="ErrorOverlay-Option5-Message">{message}</div>
        <button type="button" className="ErrorOverlay-Option5-Button" onClick={onDismiss}>
          {dismissLabel}
        </button>
      </div>
    </div>
  );
}

function ErrorOverlay() {
  const [error, setError] = useState(getError());
  const { t } = useTranslation();

  useEffect(() => {
    return subscribe(setError);
  }, []);

  const handleDismiss = () => {
    clearError();
  };

  if (!error) return null;

  const dismissLabel = t("achat.hideMessage");

  // -------- OPTION ACTIVE : décommenter celle à utiliser --------
  // return <ErrorOverlayOption1 error={error} onDismiss={handleDismiss} dismissLabel={dismissLabel} />;
  // return <ErrorOverlayOption2 error={error} onDismiss={handleDismiss} dismissLabel={dismissLabel} />;
  // return <ErrorOverlayOption3 error={error} onDismiss={handleDismiss} dismissLabel={dismissLabel} />;
  // return <ErrorOverlayOption4 error={error} onDismiss={handleDismiss} dismissLabel={dismissLabel} />;
  return <ErrorOverlayOption5 error={error} onDismiss={handleDismiss} dismissLabel={dismissLabel} />;
}

export { ErrorOverlay, ErrorOverlayOption1, ErrorOverlayOption2, ErrorOverlayOption3, ErrorOverlayOption4, ErrorOverlayOption5 };
